import React from 'react';

export default function TermsSection() {
  return (
    <div className="py-20 bg-black/20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 bg-gradient-to-r from-purple-400 to-purple-600 bg-clip-text text-transparent">
            Privacy Policy
          </h2>
          <p className="text-xl text-gray-300">Effective Date: 8th July 2024</p>
        </div>
        
        <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
          <div className="space-y-8 text-gray-300">
            <div>
              <h3 className="text-2xl font-semibold text-purple-400 mb-4">1. Introduction</h3>
              <p className="text-lg leading-relaxed">
                Welcome to PoppyPoker. This Privacy Policy describes how we collect, use, and protect your personal information when you use our app. By downloading or using our app, you agree to the terms of this Privacy Policy.
              </p>
            </div>
            
            <div>
              <h3 className="text-2xl font-semibold text-purple-400 mb-4">2. Information We Collect</h3>
              
              <div className="ml-6">
                <h4 className="text-xl font-medium text-purple-400 mb-3">2.1 Personal Information</h4>
                <p className="text-lg mb-4">We may collect the following personal information from you:</p>
                <ul className="list-disc list-inside ml-6 space-y-2 text-lg">
                  <li>Name</li>
                  <li>Email address</li>
                </ul>
              </div>
              
              <div className="ml-6 mt-6">
                <h4 className="text-xl font-medium text-purple-400 mb-3">2.2 Non-Personal Information</h4>
                <p className="text-lg mb-4">We may also collect non-personal information, including but not limited to:</p>
                <ul className="list-disc list-inside ml-6 space-y-2 text-lg">
                  <li>Device information (e.g., device model, operating system)</li>
                  <li>Log information (e.g., IP address, app usage data)</li>
                  <li>Location information (if location services are enabled)</li>
                  <li>Cookies and similar technologies</li>
                </ul>
              </div>
            </div>
            
            <div>
              <h3 className="text-2xl font-semibold text-purple-400 mb-4">3. How We Use Your Information</h3>
              <p className="text-lg mb-4">We use the information we collect for the following purposes:</p>
              <ul className="list-disc list-inside ml-6 space-y-2 text-lg">
                <li>To provide, operate, and maintain our app</li>
                <li>To improve, personalize, and expand our app</li>
                <li>To understand and analyze how you use our app</li>
                <li>To develop new products, services, features</li>
              </ul>
              <p className="mt-6 text-xl font-semibold text-purple-400 bg-purple-900/20 p-4 rounded-lg border border-purple-500/30">
                None of your information will be shared with any third party.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
